/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import { Kbd } from '@mantine/core';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function ShortcutKbd({ shortcut }: { shortcut: string }) {
  /* ******************************** RENDERING ******************************* */
  return (
    <Kbd size="sm" display="flex" style={{ alignItems: 'center' }} lh="1.2em">
      {shortcut.split(/(⌘)/).map((part, i) =>
        part === '⌘' ? (
          <span key={i} style={{ fontSize: '1.5em' }}>
            ⌘
          </span>
        ) : (
          part
        ),
      )}
    </Kbd>
  );
}

export default ShortcutKbd;
